import { useCallback } from 'react';

import { newGame } from '../reducers/game';
import { numberOfLettersSelector } from '../selectors/game';
import { regionSelector } from '../selectors/settings';
import { useAppDispatch, useAppSelector } from '../store';

/* Restarts at the length already being played, using the currently picked word list. */
export const useNewGame = (): (() => void) => {
  const dispatch = useAppDispatch();
  const numberOfLetters = useAppSelector(numberOfLettersSelector);
  const region = useAppSelector(regionSelector);

  return useCallback(() => {
    if (numberOfLetters !== null) {
      dispatch(newGame({ numberOfLetters, region }));
    }
  }, [dispatch, numberOfLetters, region]);
};
